<template>
    <div class="card">
        <div class="card-body">
            <h3>Photos for Customer</h3>
            <small>Visible on customer's copy</small>
            <attachments
                v-if="formId"
                v-model="attachments"
                type="App\Form"
                :id="formId"
            />
            <p v-if="!formId">
                Please save the form before uploading customer photos
            </p>
            <span
                class="form-error"
                style="margin-top: 1rem"
                v-if="attachmentMessage"
            >Note: {{ attachmentMessage }}</span>
        </div>
    </div>
</template>

<script>
import Attachments from "../../AttachmentsComponent";
export default {
    components: {
        Attachments,
    },
    props: {
        formId: {
            required: false,
            type: [Number, String],
            default: undefined
        },
    },
    data() {
        return {
            attachments: [],
            attachmentMessage: null,
        };
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/FormPhotosComponent.vue